import { render, staticRenderFns } from "./PacoteExames.vue?vue&type=template&id=1ddc2b12&scoped=true"
import script from "./PacoteExames.vue?vue&type=script&lang=js"
export * from "./PacoteExames.vue?vue&type=script&lang=js"
import style0 from "./PacoteExames.vue?vue&type=style&index=0&id=1ddc2b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc2b12",
  null
  
)

export default component.exports